// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"470":"5b4f763a","787":"87f46d42","968":"55d62efc"}[chunkId] + ".chunk.js";
};